export default __webpack_public_path__ + "static/media/G.d2c941f1.wav";